exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fr-box .fr-view [contenteditable=\"false\"] {\n  display: inline-block;\n  margin: 0 .2rem 0;\n  border-radius: 0;\n  padding: 2px;\n  color: white;\n  font-family: \"Courier New\", Courier, monospace;\n  background-color: #0090CA;\n}\n.fr-box .fr-view [contenteditable=\"false\"].focused {\n  outline: 2px solid #2d8ac7;\n}\n.fr-box .fr-toolbar {\n  border: none;\n  border-bottom: solid 1px #ccc;\n}\n.fr-box.fr-basic .fr-wrapper {\n  border: none;\n}\n.fr-box .second-toolbar {\n  display: none;\n}\n.ant-form-item {\n  margin-bottom: 4px;\n}\n", ""]);

// exports
